import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

const URL_BACKEND = environment.urlBackend;

@Injectable({ providedIn: 'root' })
export class EstadisticasSistemaService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  private async headers(): Promise<HttpHeaders> {
    const token = await this.authService.loadJwToken();
    return new HttpHeaders({ 'x-token': token || '' });
  }

  private buildParams(query: any): HttpParams {
    let params = new HttpParams();
    Object.keys(query || {}).forEach((k) => {
      const v = query[k];
      if (v !== undefined && v !== null && v !== '') {
        params = params.set(k, String(v));
      }
    });
    return params;
  }

  async resumenSolicitudes(filtros: any): Promise<any> {
    const headers = await this.headers();
    return this.httpClient
      .post<any>(`${URL_BACKEND}/estadisticas/solicitudes/resumen`, filtros, { headers })
      .toPromise()
      .then((resp) => resp.response);
  }

  async actividadUsuarios(filtros: any): Promise<any> {
    const headers = await this.headers();
    return this.httpClient
      .post<any>(`${URL_BACKEND}/estadisticas/solicitudes/actividad-usuarios`, filtros, { headers })
      .toPromise()
      .then((resp) => resp.response);
  }

  async credenciales(query: any): Promise<any> {
    const headers = await this.headers();
    return this.httpClient
      .get<any>(`${URL_BACKEND}/estadisticas/credenciales`, {
        headers,
        params: this.buildParams(query),
      })
      .toPromise()
      .then((resp) => resp.response);
  }

  async ordenes(query: any): Promise<any> {
    const headers = await this.headers();
    return this.httpClient
      .get<any>(`${URL_BACKEND}/estadisticas/ordenes`, {
        headers,
        params: this.buildParams(query),
      })
      .toPromise()
      .then((resp) => resp.response);
  }

  async solicitudesPorTipoTramite(filtros: any): Promise<any> {
    const headers = await this.headers();
    return this.httpClient
      .post<any>(`${URL_BACKEND}/estadisticas/solicitudes/por-tipo-tramite`, filtros, { headers })
      .toPromise()
      .then((resp) => resp.response);
  }
}
